import { createContext } from 'react';

export type SingleCollectionCtx = {
  showSingleCollectionErrorAlert: boolean;
  singleCollectionError: string;
  showSingleCollectionConfirmAlert: boolean;
};

const SingleCollectionDialogueContext = createContext<SingleCollectionCtx>({
  showSingleCollectionErrorAlert: false,
  singleCollectionError: '',
  showSingleCollectionConfirmAlert: false,
});

export default SingleCollectionDialogueContext;